export const forum = {
  alerts: {
    createComment: {
      error: 'Une erreur s’est produite lors de la création de votre commentaire.',
      success: 'Votre commentaire a été publié.',
    },
    createPost: {
      error: 'Une erreur s’est produite lors de la création de votre publication.',
      success: 'Votre publication a été créée.',
    },
    deleteComment: {
      error: 'Une erreur s’est produite lors de la suppression de votre commentaire.',
      success: 'Votre commentaire a été supprimé.',
    },
    deletePost: {
      error: 'Une erreur s’est produite lors de la suppression de votre publication.',
      success: 'Votre publication a été supprimée.',
    },
    editComment: {
      error: 'Une erreur s’est produite lors de la modification de votre commentaire.',
      success: 'Votre commentaire a été modifié.',
    },
    editPost: {
      error: 'Une erreur s’est produite lors de la modification de votre publication.',
      success: 'Votre publication a été modifiée.',
    },
  },
  breadcrumb: {
    guidelines: 'Règles',
    root: 'Forum',
    saved: 'Publications sauvegardées',
    self: 'Mes publications',
  },
  comments: {
    communityProfileRequired: {
      action: 'Rendre le profil public',
      description: 'Pour commenter, vous avez besoin d’un profil Community public.',
    },
    error: {
      title: 'Erreur lors du chargement des commentaires.',
    },
    titleUnknown: 'Commentaires',
    title_one: '{{count}} commentaire',
    title_other: '{{count}} commentaires',
  },
  createComment: {
    actions: {
      comment: 'Commenter',
    },
  },
  createPost: {
    actions: {
      post: 'Publier',
    },
    disclaimer: 'Pouvez-vous d’abord lire les <guidelinesLink>règles de la Community</guidelinesLink> avant de publier ?',
    fields: {
      content: {
        label: 'Contenu',
      },
      tag: {
        description: 'Choisissez le tag qui correspond le mieux à votre publication.',
        label: 'Tag',
      },
      title: {
        label: 'Titre',
      },
    },
    title: 'Créer une publication',
  },
  deleteComment: {
    actions: {
      confirm: 'Supprimer le commentaire',
    },
    description: 'Voulez-vous vraiment supprimer votre commentaire ?',
    title: 'Supprimer le commentaire',
  },
  deletePost: {
    actions: {
      confirm: 'Supprimer la publication',
      confirmUnable: 'Compris',
    },
    description: 'Voulez-vous vraiment supprimer votre publication « {{title}} » ?',
    descriptionUnable:
      'Vous ne pouvez pas supprimer votre publication, car d’autres freelances l’ont commentée.<br/>Vous souhaitez tout de même la supprimer ? Contactez <emailLink href="mailto:community@creativeshelter.be">community@creativeshelter.be</emailLink> et nous ferons le nécessaire.',
    title: 'Supprimer la publication',
    titleUnable: 'Suppression impossible',
  },
  guidelines: {
    content:
      '<introduction>Les règles du jeu de la Community. Pas parce que c’est un jeu qu’on peut gagner, mais on peut peut-être mettre quelqu’un échec et mat avec une remarque pertinente. Gentiment, bien sûr, emballé dans du coton et du papier bulle.</introduction>\n\n<subtitle>On reste bienveillants. On est d’accord ?</subtitle>\n\n<paragraph>Le forum a été créé pour vous et tous les autres membres de Creative Shelter, mais nous gardons un œil sur tout. Les grossièretés, les remarques racistes, les comportements homophobes… n’y ont pas leur place.</paragraph>\n\n<paragraph>Le mot d’ordre : soyez bienveillants les uns envers les autres.</paragraph>\n\n<subtitle>Il n’y a pas de questions ou de réponses stupides</subtitle>\n\n<paragraph>Tous les membres peuvent réagir, donner des conseils ou partager leur avis sur les questions posées sur le forum. Il se peut donc que vous ne soyez pas d’accord avec tout ou qu’une petite erreur se glisse dans une réponse. Là aussi, la règle est la même : soyez bienveillants les uns envers les autres. Bref, tolérance avant tout !</paragraph>\n\n<paragraph>Une question juridique, des conseils sur la comptabilité ou les droits d’auteur ? Il se peut que Creative Shelter réponde elle-même.</paragraph>\n\n<subtitle>Des informations sensibles ? Elles restent entre les murs de la Community.<br />Ce qui se passe sur le forum reste sur le forum.</subtitle>\n\n<paragraph>Les situations sensibles, les tarifs horaires, l’adresse de la grand-mère de quelqu’un… on ne les répète pas. Le forum est justement l’endroit pour discuter et échanger sur ce genre de sujets dans un environnement sûr, sans que ça fasse soudain le tour. Pour les ragots, direction le groupe de discussion avec vos amis.</paragraph>',
    header: {
      title: 'Règles de la Community',
    },
  },
  moderatorDialog: {
    introduction:
      'Je garde un œil sur tout ! Juste pour m’assurer que tout le monde reste bienveillant et que l’ambiance reste conviviale ici. Des questions ou des compliments ? N’hésitez pas à me les envoyer !',
  },
  overview: {
    error: {
      title: 'Erreur lors du chargement du forum.',
    },
    header: {
      title: 'Forum de la Community',
    },
    postPreview: {
      pinned: 'Épinglé',
    },
    savedPosts: {
      empty: 'Vous n’avez pas encore sauvegardé de publications.',
      error: {
        title: 'Erreur lors du chargement de vos publications sauvegardées.',
      },
      title: 'Publications sauvegardées',
    },
    selfPosts: {
      empty: 'Vous n’avez pas encore créé de publication.',
      error: {
        title: 'Erreur lors du chargement de vos publications.',
      },
      title: 'Vos publications',
    },
    timeline: {
      empty: 'Rien n’a encore été publié.',
      error: {
        title: 'Erreur lors du chargement de votre page d’accueil.',
      },
      title: 'Page d’accueil',
    },
  },
  post: {
    card: {
      actions: {
        comment: 'Commenter',
        comments: '{{count}} commentaires',
        like: 'J’aime ({{count}} j’aime)',
      },
      edited: 'modifié',
    },
    error: {
      title: 'Erreur lors du chargement de la publication.',
    },
    systemMessages: {
      CommentDeletedByModerator:
        '{{moderator, ucfirst}} a supprimé ce commentaire, car il ne respecte pas nos <guidelinesLink>règles</guidelinesLink>.',
      CommentDeletedByUser: 'Ce commentaire a été supprimé.',
      LockedByModerator: '{{moderator, ucfirst}} a verrouillé cette publication. Il n’est plus possible de commenter.',
      MovedByModerator: '{{moderator, ucfirst}} a déplacé cette publication de <bold>{{oldTag}}</bold> vers <bold>{{newTag}}</bold>.',
      unknownModerator: 'Un modérateur',
    },
  },
  sidebar: {
    sections: {
      favoriteTags: 'Tags favoris',
      quickLinks: 'Liens utiles',
      tags: 'Tous les tags',
    },
    toggleFavoriteTag: 'Marquer {{tag}} comme favori',
  },
  tags: {
    Announcements: {
      name: 'Annonces',
    },
    Audiovisual: {
      name: 'Audiovisuel',
    },
    DigitalDesign: {
      name: 'Design digital',
    },
    FreelanceLife: {
      name: 'Vie de freelance',
    },
    ItDevelopment: {
      name: 'Développement informatique',
    },
    LanguageAndCommunication: {
      name: 'Langue et communication',
    },
    OnlineContentCreation: {
      name: 'Création de contenu en ligne et storytelling',
    },
    PerformingArtists: {
      name: 'Artiste de scène',
    },
    Photography: {
      name: 'Photographie',
    },
    VisualCommunication: {
      name: 'Communication visuelle',
    },
  },
};
